import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Импорт',
      title: 'Файлы импорт',
      executeAction: 'Отправить',
      errorMessage: 'Ошибка',
      successMessage: 'Запрос отправлен',
      fields: {
      },
    }
  }
}